import { render, staticRenderFns } from "./PanelInfos.vue?vue&type=template&id=4f1460f7&"
import script from "./PanelInfos.vue?vue&type=script&lang=js&"
export * from "./PanelInfos.vue?vue&type=script&lang=js&"
import style0 from "./PanelInfos.vue?vue&type=style&index=0&id=4f1460f7&prod&lang=css&"
import style1 from "./PanelInfos.vue?vue&type=style&index=1&id=4f1460f7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports